import { Editor } from 'grapesjs';
import { MutableRefObject } from 'react';

export const NEW_TAG = {
  pages: [
    {
      name: 'Tag',
      component: '<section id="tag-layout" data-gjs-type="tag"></section>',
      styles: `#tag-layout { width: 4in; height: 2in; }
        * { font-family: Montserrat; }
      `,
    },
  ],
};

export default function createPalletTagStoragePlugin({
  saveRemote,
  loadRemote,
  tagConfig,
  setStorageSaveModalOpen,
  setStorageLoadModalOpen,
}: {
  saveRemote: (saveState, pages, metadata: { name: string; width: number; height: number }) => Promise<{ id: number }>;
  loadRemote: () => Promise<any>;
  tagConfig: MutableRefObject<{ name: string; width: number; height: number }>;
  setStorageSaveModalOpen: (open: boolean) => void;
  setStorageLoadModalOpen: (open: boolean) => void;
}) {
  return (editor: Editor) => {
    const commands = editor.Commands;

    commands.add('save-changes', {
      run: () => {
        setStorageSaveModalOpen(true);
      },
    });

    commands.add('open-document', {
      run: () => {
        setStorageLoadModalOpen(true);
      },
    });

    commands.add('reload-changes', {
      run: () => {
        editor.load({ remote: true });
      },
    });

    editor.StorageManager.add<{
      remote: boolean;
      tagName: string;
      tagConfig: { width: number; height: number };
      generationOptions: any;
    }>('hybrid', {
      async load({ remote }) {
        if (!remote) {
          const dataString = localStorage.getItem(`temp-store-tag-${tagConfig.current.name}`);

          if (dataString) {
            return JSON.parse(dataString);
          }
        }

        const remoteData = await loadRemote();

        if (!remoteData) {
          return NEW_TAG;
        }

        return remoteData;
      },
      store(data, { remote }) {
        console.debug('Storing data', data);

        if (!remote) {
          localStorage.setItem(`temp-store-tag-${tagConfig.current.name}`, JSON.stringify(data, null, 2));

          return Promise.resolve();
        }

        const pages = editor.Pages.getAll().map((page) => {
          const component = page.getMainComponent();
          return { html: editor.getHtml({ component }), css: editor.getCss({ component, keepUnusedStyles: true }) };
        });

        return saveRemote(data, pages, tagConfig.current);
      },
    });
  };
}
